<template>
  <ul
    class="Documents"
    :class="{
      'Documents--isEditMode': isEditMode,
    }"
  >
    <li
      v-for="(document, index) in list"
      :key="index"
      class="d-flex Documents_item pa-4 mb-2"
      :class="{
        'Documents_item--success': document.status === DOCUMENT_CHECK_STATUSES.isSuccess,
        'Documents_item--missing': document.status === DOCUMENT_CHECK_STATUSES.isMissing,
        'Documents_item--invalid': document.status === DOCUMENT_CHECK_STATUSES.isInvalid,
      }"
    >
      <p class="flex-grow-1 label d-flex flex-row ma-0">
        <span class="d-flex align-center">
          <span
            v-if="document.status === DOCUMENT_CHECK_STATUSES.isSuccess"
            class="Documents_item_icon mr-2"
          >
            <v-img :src="'./assets/icons/file-icon.svg'" />
          </span>
          {{ $t(`main.enums.documents.${document.id}`) }}
        </span>
        <span
          v-if="document.status === DOCUMENT_CHECK_STATUSES.isInvalid"
          class="Documents_status"
        >
          {{ $t('main.documents.wording.invalid') }}
        </span>
      </p>
      <v-btn
        v-if="document.actionLabel"
        x-small
        text
        class="theme-btn app-button-primary color"
        @click="onClick(document)"
      >
        {{ document.actionLabel }}
      </v-btn>
    </li>
  </ul>
</template>

<script>
  import { DOCUMENT_STATUSES, DOCUMENT_CHECK_STATUSES } from '@/components/ui/inputs/FileInput.const'
  const EDIT_STATUS_ACTION_LABEL_KEYS = {
    [DOCUMENT_CHECK_STATUSES.isSuccess]: 'common.action.update-doc',
    [DOCUMENT_CHECK_STATUSES.isMissing]: 'common.action.add-document',
    [DOCUMENT_CHECK_STATUSES.isInvalid]: 'common.action.update-doc',
  }
  const STATUS_ACTION_LABEL_KEYS = {
    [DOCUMENT_CHECK_STATUSES.isSuccess]: 'common.addedOn',
    [DOCUMENT_CHECK_STATUSES.isMissing]: 'main.enums.status.missing',
    [DOCUMENT_CHECK_STATUSES.isInvalid]: 'main.enums.status.invalid',
  }

  export default {
    props: {
      documents: {
        type: Array,
        required: true,
      },
      isEditMode: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        DOCUMENT_CHECK_STATUSES,
      }
    },
    computed: {
      list() {
        return this.documents.map((document) => {
          const isReadOnly = document.data && document.data.status === DOCUMENT_STATUSES.sent_to_unicia
          const labelKey = this.isEditMode
            ? EDIT_STATUS_ACTION_LABEL_KEYS[document.status]
            : STATUS_ACTION_LABEL_KEYS[document.status]
          const date = document.date ? this.$d(new Date(document.date)) : ''
          const actionLabel = isReadOnly ? '' : this.$t(labelKey, { date, })

          return {
            ...document,
            actionLabel,
          }
        })
      },
    },
    methods: {
      onClick(document) {
        if (this.isEditMode) {
          this.$emit('show-upload-modal', document)
        }
      },
    },
  }
</script>

<style scoped lang="scss">
// @todo : import this file once for all
@import '~@/styles/app.scss';

$label-success: $color-001c4b;
$label-missing: $color-f07d00;
$label-invalid: $color_ea3b38;

$action-success: $color-009ee0;
$action-missing: $color-f07d00;
$action-invalid: $color_ea3b38;

$bg-success: $color-f5f6fa;
$bg-missing: $color-240_125_0_04;
$bg-invalid: $color-234_59_56_04;

.Documents {
  $root: &;
  padding: 0;

  &_item {
    &_icon {
      width: 2rem;
    }
    .label {
      color: $color-001c4b;
      letter-spacing: 0;
      line-height: 20px;
      font-weight: $font-weight-medium;
    }

    &--success {
      background: $bg-success;

      .label {
        color: $label-success;
      }
      .actionLabel {
        color: $action-success;
      }
    }

    &--missing {
      border: 1px dashed $label-missing;
      background: $bg-missing;

      .label {
        color: $label-missing;
      }
      .actionLabel {
        color: $action-missing;
      }
    }

    &--invalid {
      border: 1px dashed $label-invalid;
      background: $bg-invalid;

      .label {
        color: $label-invalid;
      }
      .actionLabel {
        color: $action-invalid;
      }
    }
  }
  &_status {
    font-size: 11px;
  }
}
</style>
